import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/wage-actions.module.scss';
import { IWage } from 'src/types/wage';
import DeleteWageAction from './DeleteWageAction';

const WageActionsColumn: React.FunctionComponent<CellProps<IWage>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IWage>) => {
    return (
        <div className={classNames(styles.actions)}>
            <Link to={Router.generate(routes.WAGE_EDIT, { id: original.id })} className="btn btn-info">
                <FontAwesomeIcon icon={faPencilAlt} />
            </Link>
            <DeleteWageAction data={original} />
        </div>
    );
};

export default WageActionsColumn;
